/**
 * Módulo para funcionalidades especiales (país, archivos, firma, etc.)
 */

export class SpecialFeatures {
    
    /**
     * Configura el selector de país (compatible con implementación original)
     */
    static setupCountrySelector(form) {
        // Verificar si hay campos de teléfono para configurar
        if (!window["vars_" + form.name] || !window["vars_" + form.name].zf_FieldArray) {
            return;
        }
        
        const zf_FieldArray = window["vars_" + form.name].zf_FieldArray;
        
        if (zf_FieldArray.indexOf('PhoneNumber_countrycodeVal') === -1) {
            return; // No hay campo de teléfono para configurar
        }
        
        // Usar los mismos IDs que la implementación original
        const dropdownID = form.name + '_country-list-dropdown';
        const inputID = form.name + '_international_PhoneNumber_countrycodeval';
        
        const dropdown = document.getElementById(dropdownID);
        const input = document.getElementById(inputID);
        
        if (!dropdown || !input) return;

        console.log("Configuring country selector for form: " + form.name);

        // Configurar event listeners para el dropdown
        dropdown.addEventListener('click', function(e) {
            if (e.target.classList.contains('zfm-country-option')) {
                const countryCode = e.target.getAttribute('data-country-code');
                const countryName = e.target.getAttribute('data-country-name');
                const flagClass = e.target.getAttribute('data-flag-class');
                
                // Actualizar el input con el código de país
                input.value = countryCode;
                
                // Actualizar la visualización si existe
                const selectedCountry = dropdown.previousElementSibling;
                if (selectedCountry && selectedCountry.classList.contains('zfm-selected-country')) {
                    selectedCountry.innerHTML = `<div class="iti-flag ${flagClass}"></div> ${countryName} ${countryCode}`;
                }
                
                // Cerrar dropdown
                dropdown.style.display = 'none';
            }
        });

        // Cerrar dropdown al hacer click fuera
        document.addEventListener('click', function(e) {
            if (!dropdown.contains(e.target) && !e.target.closest('.zfm-country-selector')) {
                dropdown.style.display = 'none';
            }
        });
    }

    /**
     * Configura la subida de archivos (mantener implementación original)
     */
    static setupFileUpload(form) {
        // Llamar a la función original que funciona
        if (typeof zfm_init_file_upload === 'function') {
            zfm_init_file_upload(form);
        } else {
            // Fallback a la implementación nueva si no existe la original
            this.setupFileUploadNew(form);
        }
    }

    /**
     * Nueva implementación de subida de archivos
     */
    static setupFileUploadNew(form) {
        const fileInput = document.getElementById(`${form.name}_FileUpload`);
        if (!fileInput) return;

        const fileSelector = document.getElementById(`${form.name}_FileUpload_select_file`);
        const fileListContainer = document.getElementById(`${form.name}_file-list`);
        
        if (!fileListContainer) return;

        let selectedFiles = [];

        // Configurar el input para aceptar solo PDFs
        fileInput.setAttribute('accept', '.pdf,application/pdf');

        function updateFileInput() {
            const dataTransfer = new DataTransfer();
            selectedFiles.forEach(file => {
                dataTransfer.items.add(file);
            });
            fileInput.files = dataTransfer.files;
        }

        function toggleUploadArea() {
            // Ocultar/mostrar el área de subida según si hay archivos
            if (fileSelector) {
                fileSelector.style.display = selectedFiles.length > 0 ? 'none' : 'flex';
            }
            // También ocultar el input file si existe
            if (fileInput.parentElement) {
                const uploadArea = fileInput.closest('.zfm-upload-area') || fileInput.parentElement;
                if (uploadArea !== fileListContainer) {
                    uploadArea.style.display = selectedFiles.length > 0 ? 'none' : 'flex';
                }
            }
        }

        function renderFileList() {
            fileListContainer.innerHTML = '';
            selectedFiles.forEach((file, idx) => {
                const fileItem = document.createElement('div');
                fileItem.className = 'zfm-file-item';
                fileItem.innerHTML = '<span class="zfm-filename">' + file.name + '</span>';
                fileItem.title = file.name;

                // Botón para eliminar archivo
                const removeBtn = document.createElement('button');
                removeBtn.innerHTML = '×';
                removeBtn.className = 'zfm-file-remove';
                removeBtn.addEventListener('click', () => {
                    selectedFiles.splice(idx, 1);
                    updateFileInput();
                    renderFileList();
                    toggleUploadArea(); // Mostrar área de subida cuando se elimina el archivo
                });

                fileItem.appendChild(removeBtn);
                fileListContainer.appendChild(fileItem);
            });

            toggleUploadArea(); // Actualizar visibilidad del área de subida
        }

        function validatePdfFile(file) {
            // Validar que sea un PDF
            const isPdfByExtension = file.name.toLowerCase().endsWith('.pdf');
            const isPdfByMime = file.type === 'application/pdf';
            
            return isPdfByExtension || isPdfByMime;
        }

        function validateFileSize(file) {
            // Verificar el tamaño del archivo usando ZFM_VARS.max_file_size
            if (typeof ZFM_VARS !== 'undefined' && ZFM_VARS.max_file_size) {
                const maxSize = parseInt(ZFM_VARS.max_file_size);
                return file.size <= maxSize;
            }
            return true; // Si no hay límite configurado, permitir
        }

        function formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        }

        function getMaxFileSizeFormatted() {
            if (typeof ZFM_VARS !== 'undefined' && ZFM_VARS.max_file_size) {
                return formatFileSize(parseInt(ZFM_VARS.max_file_size));
            }
            return '2 MB'; // Default
        }

        function showError(message) {
            let errorDiv = document.getElementById(`${form.name}_FileUpload_error`);
            if (!errorDiv) {
                errorDiv = document.createElement('div');
                errorDiv.id = `${form.name}_FileUpload_error`;
                errorDiv.className = 'zfm-file-error';
                errorDiv.style.color = 'red';
                errorDiv.style.fontSize = '12px';
                errorDiv.style.marginTop = '5px';
                fileListContainer.parentNode.insertBefore(errorDiv, fileListContainer.nextSibling);
            }
            errorDiv.textContent = message;
            errorDiv.style.display = 'block';
            
            // Ocultar error después de 5 segundos
            setTimeout(() => {
                errorDiv.style.display = 'none';
            }, 5000);
        }

        function hideError() {
            const errorDiv = document.getElementById(`${form.name}_FileUpload_error`);
            if (errorDiv) {
                errorDiv.style.display = 'none';
            }
        }

        function setupFileRequirementsText() {
            // Buscar el primer label dentro de .zfm-file-box
            const fileBox = document.querySelector('.zfm-file-box');
            if (!fileBox) return;

            const label = fileBox.querySelector('label');
            if (!label) return;

            // Verificar si ya existe el texto de requisitos
            if (label.querySelector('.zfm-file-requirements')) return;

            // Obtener el tamaño máximo formateado
            const maxSizeFormatted = getMaxFileSizeFormatted();

            // Crear el elemento de requisitos
            const requirementsText = document.createElement('div');
            requirementsText.className = 'zfm-file-requirements';
            requirementsText.innerHTML = `
                <small style="color: #666; font-size: 11px; display: block; margin-top: 4px;">
                    Solo archivos PDF. Tamaño máximo: ${maxSizeFormatted}
                </small>
            `;

            // Añadir al label
            label.appendChild(requirementsText);
        }

        // Event listener para cambios en el input file
        fileInput.addEventListener('change', (e) => {
            const files = Array.from(e.target.files);
            hideError();

            // Si ya hay archivos seleccionados, reemplazar
            if (selectedFiles.length > 0) {
                selectedFiles = [];
            }

            files.forEach(file => {
                // Validar que sea PDF
                if (!validatePdfFile(file)) {
                    showError('Solo se permiten archivos PDF.');
                    return;
                }

                // Validar tamaño
                if (!validateFileSize(file)) {
                    const maxSizeFormatted = getMaxFileSizeFormatted();
                    const fileSizeFormatted = formatFileSize(file.size);
                    showError(`El archivo es demasiado grande (${fileSizeFormatted}). El tamaño máximo permitido es ${maxSizeFormatted}.`);
                    return;
                }

                // Solo permitir un archivo
                if (selectedFiles.length === 0 && !selectedFiles.some(f => f.name === file.name && f.size === file.size)) {
                    selectedFiles.push(file);
                    hideError();
                } else if (selectedFiles.length > 0) {
                    showError('Solo se permite un archivo a la vez.');
                    return;
                }
            });

            updateFileInput();
            renderFileList();
        });

        // Inicializar
        renderFileList();

        // Configurar texto de requisitos
        setupFileRequirementsText();
    }
}